import { render, staticRenderFns } from "./drawer-team-settings.vue?vue&type=template&id=5df9b35f&"
import script from "./drawer-team-settings.vue?vue&type=script&lang=js&"
export * from "./drawer-team-settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports